import Icon from '../components/Icon.vue'

Icon.register({
  'grin-squint-tears': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M409.6 111.9C432.2 108.7 483.1 99.9 497.9 85.1 517.1 65.9 516.8 34.5 497.2 14.9S446-5 426.9 14.2C412.1 29 403.4 79.9 400.1 102.5 399.3 108 404 112.7 409.6 111.9zM102.4 400.1C79.8 403.3 28.9 412.1 14.1 426.9-5 446-4.7 477.5 14.9 497.1S65.9 517 85.1 497.8C99.9 483 108.6 432.1 111.9 409.5 112.7 404 108 399.3 102.4 400.1zM414.1 143.6C381.1 147.5 365.5 118.5 368.4 97.9 371.8 73.9 375.8 55.8 379.9 41.4 285.1-13.4 161.8-0.5 80.6 80.6-0.5 161.7-13.4 285 41.4 379.9 55.8 375.8 73.8 371.9 97.9 368.4 131.1 364.5 146.5 393.6 143.6 414.1 140.2 438.1 136.2 456.2 132.1 470.6 226.9 525.4 350.2 512.5 431.4 431.4S525.4 227 470.6 132.1C456.2 136.2 438.1 140.1 414.1 143.6zM255.7 106C259 92.8 278.1 94.5 279.3 107.8L284.1 160.1 336.4 164.9C349.8 166.1 351.3 185.2 338.2 188.5L247.7 211.1C238.8 213.3 231 205.2 233.2 196.6L255.7 106zM164.8 336.3L160 284 107.7 279.2C94.3 278 92.8 258.9 105.9 255.6L196.4 233C205.2 230.8 213.1 238.8 210.9 247.5L188.3 338C185.2 351.2 166.1 349.7 164.8 336.3zM380.5 380.5C351.2 409.8 304.8 430.9 263.8 430.9 244.9 430.9 227.2 426.4 212.8 416.2 203 409.3 204.1 394.4 214.8 389 243.1 374.4 278.7 346.6 312.6 312.7S374.3 243.1 388.9 214.9C394.3 204.4 409.1 203 416.2 212.9 448.5 258.2 423.3 337.6 380.5 380.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-squint-tears.js
// module id = NYXY
// module chunks = 144